import NewReceiptDialog from './NewReceiptDialog.view';

export default NewReceiptDialog;
